import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'daysRemaining', })
export class DaysRemainingPipe implements PipeTransform {

  transform(endTimestamp?: number): number {
    if (!endTimestamp) return 0;

    const now = Date.now();
    const diffMs = endTimestamp - now;

    if (diffMs <= 0) return 0;
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  }

}
